import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
// import { CopyToClipboard } from "react-copy-to-clipboard";
// import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';

import {
  getResourceSectionsAndLinks,
} from "../../Actions/actions";

const styles = {
  root: {
    flexGrow: 1,
  },
  flex: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  tabsRoot: {
    borderBottom: '4px solid #ef6262',
  },
  tabsIndicator: {
    backgroundColor: '#1890ff',
  },

  tabSelected: {},
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#000',
    },
  },
};


class partnerDashboard extends React.Component {
  state = {
    userId: localStorage.getItem("userId"),
  };

  componentDidMount() {
    const { userId } = this.state
    const { getResourceSectionsAndLinks } = this.props
    getResourceSectionsAndLinks(userId)

  }

  render() {
    const { data: { getResourceSections } } = this.props
    return (
      <div className="p-overview p-resources">
        <div className="p-overview-heading">
          <h3 className="p-h3">Resources</h3>

        </div>
        {getResourceSections && getResourceSections.code === 200 ? getResourceSections.result.map((item) => (
          <div>
            <div className="p-resources-inner">
              <h4 className="p-h4">{item.title}</h4>
              <div className="p-resources-communication-details">
                <p>
                  <div
                    className="content settlement-detail-overview detail-title"
                    dangerouslySetInnerHTML={{
                      __html: item.description,
                    }}
                  />
                </p>
              </div>

              {/* <div className="p-resources-registration-rt">
              <div class="p-settlement-resources">
                <div class="settlement-sample-email">
                  <h5>Sample Customer Email</h5>
                  <p>Introduces customers to the Collectively filing option</p>
                  <a class="view-settlement-link" href="/settlementAffiliate/902">View Sample Customer Email</a>
                </div>
                <div class="settlement-sample-email">
                  <h5>Sample Landing Page</h5>
                  <p>Where customers enroll with Collectively</p>
                  <a class="view-settlement-link" href="/settlementAffiliate/902">Sample Landing Page</a>
                </div>
              </div>
            </div> */}
            </div>
            {item.resourceDtoList.length !== 0 ? (
                <div className="p-resources-registration-lt">
                  <div className="p-settlement-resources">
                    <h4 className="p-h5">Resources</h4>
                    <div className="link-outer-res">
                      {item.resourceDtoList.map((urlList) => (
                        <div className={`link-outer-res${item.style}`}>
                          <a href={urlList.description} target="_blank" >{urlList.title} </a>
                          {/* // <CopyToClipboard
                    //   className="p-black-btn"
                    //   text={urlList.description}
                    //   onCopy={() => ToastsStore.info("Link copied!", 5000, "toast-error-msg")}
                    // >
                    //   <a className="p-black-btn">
                    //     Copy Link
                    // </a>
                    // </CopyToClipboard> */}
                        </div>
                      ))}
                    </div>

                  </div>
                </div>) : ""}
          </div>

        )) : <div className="card resources-not-found" style={{color: "#7c7c7c"}}><h4>No Resources Found</h4></div>}
        {/* <div className="p-resources-inner">
            <h4 className="p-h4">Communication Assets</h4>
            <div className="p-resources-communication-details">
              <p>The ready-to-use assets below make it easy to provide effective communication to customers. The copy reflects our understanding of what is both accurate and legally compliant. However, partners should validate that messaging fits their needs and legal requirements when using these materials.</p>
              <p>Any and all communications to customers regarding the settlement and filing must be approved by Collectively. The settlement administrator requires that certain language is included on all communications and that there is no misleading information.</p>
            </div>
            <div className="p-resources-registration-lt">
              <div className="p-settlement-resources">
                <h4 className="p-h5">Resources</h4>
                <a className="login-link p-font-medium  p-d-flex" href="/settlementAffiliate/902">Longlinknamehere</a>
                <a className="copy-btn" href="/settlementAffiliate/902">Copy Link</a>
              </div>
            </div>
            <div className="p-resources-registration-rt">
              <div class="p-settlement-resources">
                <div class="settlement-sample-email">
                  <h5>Sample Customer Email</h5>
                  <p>Introduces customers to the Collectively filing option</p>
                  <a class="view-settlement-link" href="/settlementAffiliate/902">View Sample Customer Email</a>
                </div>
                <div class="settlement-sample-email">
                  <h5>Sample Landing Page</h5>
                  <p>Where customers enroll with Collectively</p>
                  <a class="view-settlement-link" href="/settlementAffiliate/902">Sample Landing Page</a>
                </div>
              </div>
            </div> */}
        {/* <div className="blue-rectangle-outer">
            <h5 className="p-h5">HTML Emails Files & Copy</h5>
            <div className="blue-rectangle">
              <div className="blue-rectangle-lt">
                <h6 className="text-uppercase p-font-bold">Introduction Email</h6>
                <p>These are individually prepared provided by Collectively for each ISO.</p>
              </div>
              <div className="blue-rectangle-rt">
                <a className="view-link p-font-medium" href="javascript:;">View Example</a>
              </div>
            </div>
            <div className="blue-rectangle">
              <div className="blue-rectangle-lt">
                <h6 className="text-uppercase p-font-bold">Follow UP Email</h6>
                <p>The brief message reiterates the value in filing for customers.</p>
              </div>
              <div className="blue-rectangle-rt">
                <a className="view-link p-font-medium" href="javascript:;">View <i class="fa16 far fa-file-pdf"></i></a>
              </div>
            </div>
            <div className="blue-rectangle">
              <div className="blue-rectangle-lt">
                <h6 className="text-uppercase p-font-bold">Filing Deadline Email</h6>
                <p>This copy outlines filing deadlines options for customers.</p>
              </div>
              <div className="blue-rectangle-rt">
                <a className="view-link p-font-medium" href="javascript:;">View <i class="fa16 far fa-file-pdf"></i></a>
              </div>
            </div>
          </div> */}
        {/* <div className="blue-rectangle-outer">
            <h5 className="p-h5">Collectively Icon Package</h5>
            <h5 className="p-h5 subhdr">The Collectively icon package contains a comprehensive set of graphic files</h5>
            <div className="blue-rectangle">
              <div className="blue-rectangle-lt">
                <h6 className="text-uppercase p-font-bold">Package Includes:</h6>
                <p>CMYK Illustrator file</p>
                <p>RGB Photoshop files</p>
                <p>Pre-Sized images in GIF, .PNG and .JPG formats.</p>
              </div>
              <div className="blue-rectangle-rt">
                <a className="view-link p-font-medium" href="javascript:;">Download Package <i class="fa16 fas fa-file-download"></i></a>
              </div>
            </div>
            <div className="blue-rectangle">
              <div className="blue-rectangle-lt">
                <h6 className="text-uppercase p-font-bold">Follow UP Email</h6>
                <p>The brief message reiterates the value in filing for customers.</p>
              </div>
              <div className="blue-rectangle-rt">
                <a className="view-link p-font-medium" href="javascript:;">View <i class="fa16 far fa-file-pdf"></i></a>
              </div>
            </div>
            <div className="blue-rectangle">
              <div className="blue-rectangle-lt">
                <h6 className="text-uppercase p-font-bold">Filing Deadline Email</h6>
                <p>This copy outlines filing deadlines options for customers.</p>
              </div>
              <div className="blue-rectangle-rt">
                <a className="view-link p-font-medium" href="javascript:;">View <i class="fa16 far fa-file-pdf"></i></a>
              </div>
            </div>
          </div> */}
        {/* <div className="blue-rectangle-outer">
            <h5 className="p-h5">Direct Messaging</h5>
            <div className="blue-rectangle half-rectangle-lt">
              <div className="blue-rectangle-lt">
                <h6 className="text-uppercase p-font-bold">Statement Inserts</h6>
              </div>
              <div className="blue-rectangle-rt">
                <a className="view-link p-font-medium" href="javascript:;">View <i class="fa16 far fa-file-pdf"></i></a>
              </div>
            </div>
            <div className="blue-rectangle half-rectangle-rt">
              <div className="blue-rectangle-lt">
                <h6 className="text-uppercase p-font-bold">Statement Copy</h6>
              </div>
              <div className="blue-rectangle-rt">
                <a className="view-link p-font-medium" href="javascript:;">View <i class="fa16 far fa-file-pdf"></i></a>
              </div>
            </div>
          </div>
          <div className="blue-rectangle-outer">
            <h5 className="p-h5">Presentation Materials</h5>
            <div className="blue-rectangle half-rectangle-lt">
              <div className="blue-rectangle-lt">
                <h6 className="text-uppercase p-font-bold">Powerpoint</h6>
                <p>Clearly present settlement basics in 5 slides.</p>
              </div>
              <div className="blue-rectangle-rt">
                <a className="view-link p-font-medium" href="javascript:;">View <i class="fa16 far fa-file-powerpoint"></i></a>
              </div>
            </div>
            <div className="blue-rectangle half-rectangle-rt">
              <div className="blue-rectangle-lt">
                <h6 className="text-uppercase p-font-bold">Onepager</h6>
                <p>Present settlement basics on a single page</p>
              </div>
              <div className="blue-rectangle-rt">
                <a className="view-link p-font-medium" href="javascript:;">View <i class="fa16 far fa-file-alt"></i>
                </a>
              </div>
            </div>
          </div> */}
        {/* <ToastsContainer className="toast-error-msg"
          position={ToastsContainerPosition.TOP_CENTER}
          lightBackground store={ToastsStore} /> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  data: state.data,
});


const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getResourceSectionsAndLinks,
    },
    dispatch
  );
export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(partnerDashboard));
